import { render, staticRenderFns } from "./GuFamilyBannerTable.vue?vue&type=template&id=556aa1f5&"
import script from "./GuFamilyBannerTable.vue?vue&type=script&lang=js&"
export * from "./GuFamilyBannerTable.vue?vue&type=script&lang=js&"
import style0 from "./GuFamilyBannerTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports